// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.flags-modal-container .cald-modal-body .vol-reqs-table tr th {
  font-family: "72-Regular";
}

.common-flag-modal {
  width: 39.6rem !important;
}
.common-flag-modal .modal-content {
  width: 100% !important;
}

.flags-modal-container .no-rules-text {
  background-color: #f2fbfe;
}
.flags-modal-container .modal-content {
  width: 100% !important;
}
.flags-modal-container .cald-modal-body {
  max-height: 30rem;
  min-height: 20rem;
  overflow: auto;
}
.flags-modal-container .cald-modal-body .vol-reqs-table tr th {
  font-size: 1.2rem;
  color: #6a6d70;
  padding: 0;
  padding-bottom: 0 !important;
  font-weight: normal;
}
.flags-modal-container .cald-modal-body .vol-reqs-table tr th, .flags-modal-container .cald-modal-body .vol-reqs-table tr td {
  border: none;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/common-flags-modal/common-flags-modal.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AADA;EACE,yBAAA;AAIF;AAFE;EACI,sBAAA;AAIN;;AAEE;EACE,yBAAA;AACJ;AAEI;EACI,sBAAA;AAAR;AAGE;EAGE,iBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAOQ;EACE,iBAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;EACA,mBAAA;AANV;AAQQ;EACE,YAAA;EACA,eAAA;AANV","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n\n.common-flag-modal {\n  width: 39.6rem !important;\n    \n  .modal-content{\n      width: 100% !important;\n  }\n}\n\n.flags-modal-container {\n\n  .no-rules-text{\n    background-color: #f2fbfe;\n  }\n    // width: 48rem !important;\n    .modal-content{\n        width: 100% !important;\n    }\n\n  .cald-modal-body{\n    //padding: 15px 0;\n    // padding: 2rem 0 3rem 0;\n    max-height: 30rem;\n    min-height: 20rem;\n    overflow: auto;\n    // margin-bottom: 1.5rem;\n    .vol-reqs-table{\n      tr{\n        th{\n          font-size: 1.2rem;\n          color: #6a6d70;\n          padding: 0;\n          @extend %font-regular;\n          padding-bottom: 0 !important;\n          font-weight: normal;\n        }\n        th, td{\n          border: none;\n          padding: 0.5rem;\n        }\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
